import { createContext, useContext } from "react";

export interface ExpressionBuilderContextType {
  renderContext: "audience" | "pageTargeting";
  isRolloutView?: boolean;
  viewOnly?: boolean;
}

export const ExpressionBuilderContext = createContext<
  ExpressionBuilderContextType | undefined
>(undefined);

export const useExpressionBuilderContext = () =>
  useContext(ExpressionBuilderContext);
